import React from 'react';
import Select from 'react-select';

export default function SelectBoxHandler({
  Label = "",
  Options = [],
  Name = "select",
  setFormData,
  form_data,
  MultiSelection = false,
  IsLabel = true,
  is_disabled = false
}) {
  const handleChange = (selectedOption) => {
    if (MultiSelection) {
      const values = selectedOption.map(item => item.value);
      setFormData({ ...form_data, [Name]: values });
    } else {
      setFormData({ ...form_data, [Name]: selectedOption?.value || "" });
    }
  };

  // Determine current value(s) from form data
  const currentValue = MultiSelection
    ? Options.filter(option => form_data[Name]?.includes(option.value))
    : Options.find(option => option.value === form_data[Name]) || null;

  return (
    <div className='form-group mb-3'>
      {IsLabel && <label className="form-label">{Label}</label>}
      <Select
        options={Options}
        value={currentValue}
        onChange={handleChange}
        isMulti={MultiSelection}
        classNamePrefix="react-select"
        placeholder={`Select ${Label}`}
        isDisabled={is_disabled}
      />
    </div>
  );
}
